export default "__VITE_ASSET__CJHiZADF__"